import { shipmentStatuses } from '@reveni-io/reveni-ui'

export const getPickableParcels = parcels => {
  const parcelsWithRelated = parcels?.filter(parcel => parcel.related)

  if (!parcelsWithRelated) return []

  const allRequested = parcelsWithRelated.every(parcel => parcel.status === shipmentStatuses.requested)

  return allRequested ? parcelsWithRelated : []
}
